import { TelefonosGeneralesPage } from './../pages/telefonos-generales/telefonos-generales';
import { CategoriaNoticiasGeneralesPage } from './../pages/categoria-noticias-generales/categoria-noticias-generales';
import { ContactoPage } from './../pages/contacto/contacto';
import { LugarInteresPage } from './../pages/lugar-interes/lugar-interes';
import { FiestaPage } from './../pages/fiesta/fiesta';
import { CategoriaOfertasPage } from './../pages/categoria-ofertas/categoria-ofertas';
import { CategoriaNoticiasPage } from './../pages/categoria-noticias/categoria-noticias';
import { LugaresInteresPage } from './../pages/lugares-interes/lugares-interes';
import { FiestasPage } from './../pages/fiestas/fiestas';
import { AsociacionesPage } from './../pages/asociaciones/asociaciones';
import { AccordionListComponent } from './../components/accordion-list/accordion-list';
import { MasInformacionPage } from './../pages/mas-informacion/mas-informacion';
import { PuebloTabsPage } from './../pages/pueblo-tabs/pueblo-tabs';
import { PuebloInfoPage } from './../pages/pueblo-info/pueblo-info';
import { ListaPueblosPage } from './../pages/lista-pueblos/lista-pueblos';
import { ListaEmpresas } from './../pages/lista-empresas/lista-empresas';
import { PuebloMenuPage } from './../pages/pueblo-menu/pueblo-menu';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { ListaCategorias } from '../pages/lista-categorias/lista-categorias';
import { EmpresaSinglePage } from '../pages/empresa-single/empresa-single';

import { HttpModule } from '@angular/http';
import { Consultas } from '../providers/consultas';
import { VariablesGlobales } from '../providers/variables-globales';
import { BuscadorPage } from '../pages/buscador/buscador';
import { BackgroundImageDirective } from '../directives/background-image/background-image';
import { SplashscreenPage } from '../pages/splashscreen/splashscreen';
import { CategoriaComponent } from '../components/categoria/categoria';
import { PipesModule } from '../pipes/pipes.module';
import { OfertaPage } from '../pages/oferta/oferta';
import { OfertasPage } from '../pages/ofertas/ofertas';
import { NoticiaPage } from '../pages/noticia/noticia';
import { NoticiasPage } from '../pages/noticias/noticias';
import { TelefonosPage } from '../pages/telefonos/telefonos';
import { NoticiasGeneralesPage } from '../pages/noticias-generales/noticias-generales';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { MapaProvinciasPage } from '../pages/mapa-provincias/mapa-provincias';
import { CabeceraComponent } from '../components/cabecera/cabecera';
import { CabeceraTituloComponent } from '../components/cabecera-titulo/cabecera-titulo';
import { FiltroPage } from '../pages/filtro/filtro';
import { ListaProvinciasPage } from '../pages/lista-provincias/lista-provincias';
import { BarriosPage } from '../pages/lista-barrios/lista-barrios';
import { CiudadZonasPage } from '../pages/lista-zonas-ciudad/lista-zonas-ciudad';

@NgModule({
  declarations: [
    MyApp,
    ListaCategorias,
    BuscadorPage,
    BackgroundImageDirective,
    EmpresaSinglePage,
    SplashscreenPage,
    CategoriaComponent,
    CabeceraComponent,
    CabeceraTituloComponent,
    PuebloMenuPage,
    ListaEmpresas,
    ListaPueblosPage,
    PuebloInfoPage,
    PuebloTabsPage,
    MasInformacionPage,
    AccordionListComponent,
    OfertaPage,
    OfertasPage,
    NoticiaPage,
    NoticiasPage,
    AsociacionesPage,
    FiestasPage,
    LugaresInteresPage,
    TelefonosPage,
    CategoriaNoticiasPage,
    CategoriaOfertasPage,
    NoticiasGeneralesPage,
    FiestaPage,
    LugarInteresPage,
    ContactoPage,
    CategoriaNoticiasGeneralesPage,
    TelefonosGeneralesPage,
    MapaProvinciasPage,
    FiltroPage,
    ListaProvinciasPage,
    BarriosPage,
    CiudadZonasPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp,{tabsPlacement: 'top'}),
    PipesModule,
    IonicImageViewerModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    BuscadorPage,
    ListaCategorias,
    EmpresaSinglePage,
    SplashscreenPage,
    CategoriaComponent,
    CabeceraComponent,
    CabeceraTituloComponent,
    PuebloMenuPage,
    ListaEmpresas,
    ListaPueblosPage,
    PuebloInfoPage,
    PuebloTabsPage,
    MasInformacionPage,
    AccordionListComponent,
    OfertaPage,
    OfertasPage,
    NoticiaPage,
    NoticiasPage,
    AsociacionesPage,
    FiestasPage,
    LugaresInteresPage,
    TelefonosPage,
    CategoriaNoticiasPage,
    CategoriaOfertasPage,
    NoticiasGeneralesPage,
    FiestaPage,
    LugarInteresPage,
    ContactoPage,
    CategoriaNoticiasGeneralesPage,
    TelefonosGeneralesPage,
    MapaProvinciasPage,
    FiltroPage,
    ListaProvinciasPage,
    BarriosPage,
    CiudadZonasPage
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Consultas,
    VariablesGlobales,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts